import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchLeaveTypes = ({ accountId }) => get(`/accounts/${accountId}/leave-types`);

export const addLeaveType = ({ accountId, name, paycode, isPaid }) =>
  post(`/accounts/${accountId}/leave-types`, { name, paycode, isPaid });

export const updateLeaveType = ({ accountId, leaveTypeId, name, paycode, isPaid }) =>
  patch(`/accounts/${accountId}/leave-types/${leaveTypeId}`, { name, paycode, isPaid });

export const deleteLeaveType = ({ accountId, leaveTypeId }) =>
  httpDelete(`/accounts/${accountId}/leave-types/${leaveTypeId}`);
